/// <amd-module name="VSSUI/Components/FileInput/index" />
export { FileInput, FileInputState } from "./FileInput";

export {
    FileEncoding,
    FileInputContentType,
    FileInputUpdateEventData,
    FileInputResult,
    FileInputData,
    FileInputControlLimitEventData,
    IFileInputProps
} from "./FileInput.Props";
